/** Eternal City (living-city simulation) copy. Plain prose. */
export const cityEn = {
  'city.seoDescription': 'Walk into a living city. Everyone keeps a daily routine; follow them, talk with them, and spend a day beside people whose lives go on without you.',
  'city.intro': 'A living city. Everyone here keeps a daily routine, and time passes as you play. Click the map to walk, or use the lists beside it.',
  'city.back': 'Back to the globe',
  'city.quit': 'Quit',
  'city.connecting': 'Opening the city gates…',
  'city.reconnecting': 'Lost the thread. Reconnecting…',
  'city.cover.loading': 'Loading the map…',
  'city.cover.alt': 'A painting of {city}',
  'city.offline': 'The city is out of reach right now. Please try again in a little while.',
  'city.signinTitle': 'Sign in to enter',
  'city.signinBody': 'Your place in the city, your journal and the people you have met are saved to your account. Time keeps passing while you play, and some errands do not wait.',
  'city.signinCta': 'Sign in',
  'city.privacy': 'How we handle this data: Privacy Policy',
  'city.blocked': 'The city is not open to this account right now. If you think that is a mistake, please contact support.',
  'city.tableFull': 'This table is full ({cap} seats). Try again in a few minutes.',
  'city.core.title': 'Core game',
  'city.core.blurb': 'The shared game you can join after making a character, when a seat is free. Explore, meet other players and try the game.',
  'city.core.gm': 'A GameCodex GM runs this game.',
  'city.core.youGm': 'You are the GM of this game.',
  'city.core.seats': '{seated} of {cap} seats taken',
  'city.core.makeCharacter': 'Make a character to join',
  'city.core.oldTable': 'Play at the classic tabletop instead',
  'city.core.sheet': 'Character sheet',
  'city.core.line': '{lineage} {className}, level {level}',
  'city.core.stat.hp': 'HP',
  'city.core.stat.ac': 'AC',
  'city.core.stat.init': 'Init',
  'city.core.stat.prof': 'Prof',
  'city.core.evo.line': '{who}, {className}',
  'city.core.evo.power': 'Power',
  'city.core.evo.track.physical': 'Physical',
  'city.core.evo.track.mental': 'Mental',
  'city.core.evo.track.spiritual': 'Spiritual',
  'city.core.evo.track.emotional': 'Emotional',
  'city.core.evo.track.social': 'Social',
  'city.core.evo.track.temporal': 'Temporal',
  'city.core.evo.occupation': 'Occupation',
  'city.core.evo.beliefs': 'Core beliefs',
  'city.core.evo.goals': 'Skill goals',
  'city.core.evo.weapon': 'Weapon',
  'city.core.evo.items': 'Carrying',
  'city.core.evo.zero': 'Every track starts at 0 and the power die at d4. Skills are earned in play.',
  'city.openElsewhere': 'This city is open in another tab. Close that one or reload here.',
  'city.canvasLabel': 'Isometric map of {city}. Use the lists beside it to talk, walk and look around.',
  'city.hint': 'Click the ground to walk, or click a person to talk.',
  'city.holiday': 'Today: {name}',
  'city.here': 'You are at {place}.',
  'city.commons.empty': 'This is a shared space, and no other travellers are here right now.',
  'city.commons.here.one': 'This is a shared space, and one other traveller is here.',
  'city.commons.here.other': 'This is a shared space, and {count} other travellers are here.',
  'city.commons.peer': 'a fellow traveller',
  'city.crowd.name': 'Townsperson',
  'city.travel.ride': 'Ride to {place} (about {n} minutes)',
  'city.wares.now': 'Laid out now: {list}',
  'city.wares.none': 'Nothing laid out at this hour',
  'city.wares.few': '{name} (a few left)',
  'city.wares.last': '{name} (the last one)',
  'city.places': 'Go to a place',
  'city.goPlace': 'Go to {place}',
  'city.dialogueAnnounce': 'Choices are announced as they appear.',
  'city.people': 'Who is around',
  'city.peopleNone': 'Nobody in sight.',
  'city.talk': 'Talk',
  'city.goto': 'Walk over',
  'city.away': '{n} steps away',
  'city.scenes': 'Happening nearby',
  'city.watch': 'Join in',
  'city.props': 'Look around here',
  'city.examine': 'Look',
  'city.open': 'Open',
  'city.take': 'Take it',
  'city.menu.open': 'Open {thing}',
  'city.menu.take': 'Take what is in {thing}',
  'city.menu.walkToThing': 'Walk to {thing}',
  'city.dialogue': 'Conversation',
  'city.close': 'Close',
  'city.leave': 'Leave the conversation',
  'city.menu.talk': 'Talk to {name}',
  'city.menu.walkTalk': 'Walk over to {name}',
  'city.menu.walkTo': 'Walk to {name}',
  'city.menu.walkHere': 'Walk here',
  'city.menu.swimHere': 'Swim here',
  'city.menu.rowHere': 'Row here',
  'city.mount.down': 'Get down from {name}',
  'city.companion.home': 'Send {name} home',
  // the party and the ways out (travel/PartyBar): wordless singing; the server's own words come back as notes
  'city.party.label': 'With you',
  'city.party.sendHome': 'Part ways',
  'city.party.sing': 'Sing',
  'city.party.singHint': 'Press G to sing',
  'city.party.follow': 'Follow {name} down?',
  'city.party.followYes': 'Follow',
  'city.party.followNo': 'Stay',
  'city.party.askGm': 'Ask the GM to lead us down',
  'city.party.gmAsked': '{name} asks you to lead the group down.',
  'city.party.gmGo': 'Lead them down',
  'city.party.later': 'Not now',
  'city.travel.leaving': 'Going down',
  'city.travel.arriving': 'You arrive.',
  'city.fight.tag': 'Target',
  'city.fight.bar': 'Your target',
  'city.fight.target': 'Target: {name}',
  'city.fight.targetWilling': 'Target: {name} (up for a bout)',
  'city.fight.none': 'No target yet',
  'city.fight.next': 'Next target',
  'city.fight.clear': 'Clear target',
  'city.fight.never': '{name} is not someone you can fight.',
  'city.fight.nobody': 'Nobody near enough to target.',
  'city.fight.lost': 'You cannot see {name} from here.',
  'city.fight.confirm': 'Start a fight with {name}?',
  'city.fight.confirmNote': 'They are not looking for one. Nobody is hurt, and the bout ends when they yield.',
  'city.fight.yes': 'Fight',
  'city.fight.no': 'Leave it',
  'city.fight.order': 'Companions',
  'city.fight.assist': 'Assist',
  'city.fight.hold': 'Hold',
  'city.fight.assistNote': 'Your companions join in once you have struck your target, and fight back if anyone attacks you or them.',
  'city.fight.holdNote': 'Your companions stay close and guard you, but never strike.',
  'city.tactics.open': 'Tactics',
  'city.tactics.title': 'Party tactics',
  'city.tactics.intro': 'Give each companion an ordered list of rules. In a fight they read their rules from the top and do the first one that fits. The city decides what they do; this page only edits and previews. Your companions only ever fight someone you could fight yourself, and children and Ashmantle are never fought.',
  'city.tactics.name': 'Script name',
  'city.tactics.inUse': 'In use here: {name}',
  'city.tactics.inUseNone': 'In use here: the usual rules',
  'city.tactics.tabCards': 'Rules',
  'city.tactics.tabJson': 'JSON',
  'city.tactics.tabTry': 'Try it',
  'city.tactics.member': 'Companion',
  'city.tactics.role': 'Role',
  'city.tactics.usual': 'The usual rules',
  'city.tactics.presets': 'Start a role from',
  'city.tactics.preset.usual': 'The usual',
  'city.tactics.preset.defender': 'Defender',
  'city.tactics.preset.healer': 'Healer',
  'city.tactics.preset.skirmisher': 'Skirmisher',
  'city.tactics.roleLabel': 'Role name',
  'city.tactics.removeRole': 'Remove role',
  'city.tactics.when': 'When',
  'city.tactics.do': 'Do',
  'city.tactics.always': 'Always',
  'city.tactics.addCond': 'Add a condition',
  'city.tactics.addRule': 'Add a rule',
  'city.tactics.removeRule': 'Remove rule',
  'city.tactics.up': 'Move up',
  'city.tactics.down': 'Move down',
  'city.tactics.drag': 'Drag to reorder',
  'city.tactics.ruleLabel': 'What this rule is for',
  'city.tactics.not': 'not',
  'city.tactics.rest': 'Wait before using again (beats of about 2.5 seconds)',
  'city.tactics.flank': 'from the far side',
  'city.tactics.c.order': 'Your order is {is}',
  'city.tactics.c.armed': 'You have a weapon out',
  'city.tactics.c.bout': 'You are in a fight',
  'city.tactics.c.target': 'You have picked a target',
  'city.tactics.c.attacked.me': 'Someone is attacking you',
  'city.tactics.c.attacked.self': 'Someone is attacking this companion',
  'city.tactics.c.attacked.party': 'Someone is attacking the party',
  'city.tactics.c.kind': 'This companion is {is}',
  'city.tactics.c.health': '{who}: {band} or worse',
  'city.tactics.c.healthUp': '{who}: {band} or better',
  'city.tactics.c.can': 'Can use something to {kind}',
  'city.tactics.c.any': 'One of several conditions (change it in the JSON tab)',
  'city.tactics.who.me': 'You',
  'city.tactics.who.self': 'This companion',
  'city.tactics.who.target': 'Your target',
  'city.tactics.who.party': 'Anyone in the party',
  'city.tactics.band.unhurt': 'unhurt',
  'city.tactics.band.grazed': 'grazed',
  'city.tactics.band.hurt': 'hurt',
  'city.tactics.band.badly-hurt': 'badly hurt',
  'city.tactics.band.near-down': 'nearly down',
  'city.tactics.band.down': 'down',
  'city.tactics.kind.attack': 'attack',
  'city.tactics.kind.heal': 'heal',
  'city.tactics.kind.guard': 'guard',
  'city.tactics.kind.buff': 'help',
  'city.tactics.kind.control': 'hinder',
  'city.tactics.kind.utility': 'do something useful',
  'city.tactics.a.attack.target': 'Strike your foe',
  'city.tactics.a.attack.attacker': 'Strike whoever is attacking',
  'city.tactics.a.defend': 'Stay close and block',
  'city.tactics.a.guard': 'Weapons out, walk with you',
  'city.tactics.a.follow': 'Walk with you',
  'city.tactics.a.stay': 'Stay put',
  'city.tactics.a.heal.me': 'Heal you',
  'city.tactics.a.heal.self': 'Heal themselves',
  'city.tactics.a.heal.most-hurt': 'Heal whoever is most hurt',
  'city.tactics.a.use': 'Use {ability}',
  'city.tactics.at.target': 'on your foe',
  'city.tactics.at.attacker': 'on whoever is attacking',
  'city.tactics.at.me': 'on you',
  'city.tactics.at.self': 'on themselves',
  'city.tactics.at.most-hurt': 'on whoever is most hurt',
  'city.tactics.noAbilities': '{name} cannot heal under {system} yet.',
  'city.tactics.jsonNote': 'The whole script as JSON. Paste one in to import it, or copy it out to keep or share.',
  'city.tactics.applyJson': 'Read this JSON',
  'city.tactics.copy': 'Copy',
  'city.tactics.copied': 'Copied.',
  'city.tactics.download': 'Download',
  'city.tactics.importFile': 'Open a file',
  'city.tactics.tryNote': 'A practice fight against a dummy under {system}, with a fresh character in your place. It changes nothing in the city. Unlike the city, blows here do real harm, so heals have something to mend. In the city, three blows end a bout and nobody is hurt.',
  'city.tactics.tryAgain': 'Run it again',
  'city.tactics.beat': 'Beat {n}',
  'city.tactics.use': 'Use in this city',
  'city.tactics.clear': 'Back to the usual rules',
  'city.tactics.saved': 'Your companions follow this now.',
  'city.tactics.cleared': 'Your companions are back to the usual rules.',
  'city.tactics.draftNote': 'Your draft is kept in this browser. The city keeps the script you put in use.',
  'city.tactics.problems': 'Fix these first:',
  'city.tactics.warnings': 'Note:',
  'city.tactics.why': 'What your companions did, and why',
  'city.tactics.offline': 'Not connected to the city.',
  'city.tactics.healthIs': '{who}: {band}',
  'city.tactics.healHint': 'Heals only help someone who is hurt. In the city, blows do no harm, so that is rare for now.',
  'city.tactics.newRule': 'New rule',
  'city.tactics.pick': 'Pick one',
  'city.tactics.problemName': 'Give the script a name of up to 40 characters, with no links or < > { }.',
  'city.tactics.problemLabel': 'Rule and role names are up to 40 characters, with no links or < > { }.',
  'city.tactics.problemOther': 'Something in these rules cannot be used. The JSON tab says exactly what.',
  'city.tactics.orWorse': 'or worse',
  'city.tactics.orBetter': 'or better',
  'city.tactics.kind.person': 'a person',
  'city.tactics.kind.animal': 'an animal',
  'city.tactics.removeCond': 'Remove condition',
  'city.tactics.bandLabel': 'How hurt',
  'city.tactics.atLabel': 'On whom',
  'city.rumours.title': 'Rumours board',
  'city.rumours.none': 'Nothing heard yet. Stand near townsfolk talking together, at the tavern above all, and what they say is pinned here.',
  'city.rumours.said': 'said {name}',
  'city.greet.title': 'Known by name',
  'city.greet.callMe': 'What townsfolk call you',
  'city.greet.placeholder': 'Your name',
  'city.greet.none': 'No one knows you yet. Stop and talk with someone, and next time they will greet you by name.',
  'city.greet.morning.0': 'Morning, {name}!',
  'city.greet.morning.1': 'Good morning to you, {name}.',
  'city.greet.morning.2': 'Up early, {name}?',
  'city.greet.afternoon.0': 'Afternoon, {name}.',
  'city.greet.afternoon.1': 'Good day, {name}!',
  'city.greet.afternoon.2': 'Well met again, {name}.',
  'city.greet.evening.0': 'Evening, {name}.',
  'city.greet.evening.1': 'Good evening, {name}!',
  'city.greet.evening.2': 'Off home, {name}?',
  'city.greet.night.0': 'Late to be out, {name}.',
  'city.greet.night.1': 'Mind the dark, {name}.',
  'city.greet.night.2': 'Still about, {name}?',
  'city.greet.morning.0.anon': 'Morning, friend!',
  'city.greet.morning.1.anon': 'Good morning to you.',
  'city.greet.morning.2.anon': 'Up early, friend?',
  'city.greet.afternoon.0.anon': 'Afternoon, friend.',
  'city.greet.afternoon.1.anon': 'Good day to you!',
  'city.greet.afternoon.2.anon': 'Well met again.',
  'city.greet.evening.0.anon': 'Evening, friend.',
  'city.greet.evening.1.anon': 'Good evening!',
  'city.greet.evening.2.anon': 'Off home, friend?',
  'city.greet.night.0.anon': 'Late to be out, friend.',
  'city.greet.night.1.anon': 'Mind the dark.',
  'city.greet.night.2.anon': 'Still about, friend?',
  'city.market.title': 'Market board',
  'city.market.shut': 'Nothing laid out right now.',
  'city.market.later': 'Later today:',
  'city.market.am': '{n} in the morning',
  'city.market.pm': '{n} in the afternoon',
  'city.market.eve': '{n} in the evening',
  'city.garden.title': 'Garden plots',
  'city.garden.tend': 'Tend the plot',
  'city.garden.tended': 'You pull a few weeds and water the plot.',
  'city.garden.already': 'You have already tended this plot today.',
  'city.garden.tendedNote': 'tended today',
  'city.garden.arrive': 'The {crop} here are {stage}.',
  'city.garden.crop.herbs': 'herbs',
  'city.garden.crop.apples': 'apple trees',
  'city.garden.crop.kitchen': 'kitchen greens',
  'city.garden.crop.cabbages': 'cabbages and beans',
  'city.garden.crop.wheat': 'wheat fields',
  'city.garden.stage.bare': 'bare for winter',
  'city.garden.stage.sown': 'freshly sown',
  'city.garden.stage.sprouting': 'sprouting',
  'city.garden.stage.growing': 'growing well',
  'city.garden.stage.flowering': 'in flower',
  'city.garden.stage.ripe': 'ripe and ready',
  'city.garden.stage.harvested': 'harvested for the year',
  'city.fish.title': 'Fishing',
  'city.fish.cast': 'Cast a line',
  'city.fish.go': 'Go',
  'city.fish.here': 'A good fishing spot. Cast a line from the panel.',
  'city.fish.casting': 'You cast a line and wait.',
  'city.fish.caught': 'Something bites. You land {fish}.',
  'city.fish.got.boot': 'You reel in an old boot, and toss it back.',
  'city.fish.got.weed': 'Only river weed this time.',
  'city.fish.got.nothing': 'Nothing bites. The water keeps its secrets.',
  'city.fish.casts': '{n} casts so far',
  'city.fish.none': 'No casts yet. Fish bite best at dawn and dusk, and more in spring and autumn.',
  'city.fish.spot.bank': 'river bank',
  'city.fish.spot.jetty': 'jetty',
  'city.fish.spot.bridge': 'mill bridge',
  'city.fish.name.perch': 'a perch',
  'city.fish.name.roach': 'a roach',
  'city.fish.name.trout': 'a trout',
  'city.fish.name.eel': 'an eel',
  'city.fish.name.pike': 'a pike',
  'city.fish.name.carp': 'a carp',
  'city.fish.name.minnow': 'a minnow',
  'city.fish.name.crayfish': 'a crayfish',
  'city.fish.name.boot': 'an old boot',
  'city.fish.name.weed': 'river weed',
  'city.fish.name.nothing': 'nothing',
  'city.lost.title': 'Lost and found',
  'city.lost.none': 'Nothing found yet. Townsfolk drop things in the markets, the plaza and other busy places. When you stand where something lies, pick it up here.',
  'city.lost.whose': 'belongs to {name}',
  'city.lost.find': 'Find {name}',
  'city.lost.spot': 'Something lies on the ground here: {thing}',
  'city.lost.pick': 'Pick up {thing}',
  'city.lost.picked': 'You pick up {thing}. It looks like it belongs to {name}.',
  'city.lost.give': 'Give {thing} back to {name}',
  'city.lost.thanks': '{name} is glad to have {thing} back.',
  'city.lost.thing.glove': 'a lost glove',
  'city.lost.thing.keys': 'a ring of keys',
  'city.lost.thing.locket': 'a little locket',
  'city.lost.thing.toy': 'a wooden toy',
  'city.lost.thing.scarf': 'a wool scarf',
  'city.lost.thing.purse': 'an empty purse',
  'city.lost.thing.spectacles': 'a pair of spectacles',
  'city.lost.thing.letter': 'a folded letter',
  'city.lost.thing.ribbon': 'a hair ribbon',
  'city.lost.thing.pipe': 'a clay pipe',
  'city.records.title': 'City records',
  'city.records.peak': 'Busiest today at {time}, with {n} townsfolk out and about.',
  'city.records.now': 'This hour: {out} out, {home} at home.',
  'city.records.busiest': 'Busiest quarter: {district}.',
  'city.records.outTitle': 'Townsfolk out, by hour',
  'city.records.seenTitle': 'People you saw around you, by hour',
  'city.a11y.title': 'Accessibility',
  'city.a11y.text': 'Text size',
  'city.a11y.size1': 'Normal',
  'city.a11y.size125': 'Large',
  'city.a11y.size15': 'Largest',
  'city.a11y.stillOff': 'Reduce motion',
  'city.a11y.stillOn': 'Motion reduced',
  'city.a11y.contrastOff': 'High contrast',
  'city.a11y.contrastOn': 'High contrast on',
  'city.tour.welcome.title': 'Welcome to {city}',
  'city.tour.welcome.body': 'This city lives on its own clock. People wake, work, eat and sleep whether you watch or not. Here is a short look around.',
  'city.tour.walk.title': 'Walking',
  'city.tour.walk.body': 'Tap any open ground to walk there. Your robot finds its own way around walls and through doors.',
  'city.tour.talk.title': 'Talking',
  'city.tour.talk.body': 'Tap a person to see their name and walk over. Once you are close, tap again to talk. Their words appear beside their head.',
  'city.tour.menu.title': 'Looking closer',
  'city.tour.menu.body': 'On a computer, right click anything to see what you can do there, such as read a sign, sit down or take a room.',
  'city.tour.map.title': 'The minimap',
  'city.tour.map.body': 'The small map in the corner shows roads, districts and people near you. Tap it to walk there.',
  'city.tour.panel.title': 'Your panel',
  'city.tour.panel.body': 'The side panel lists the people nearby, places you have discovered, your quests, your journal and more. On a phone, open it with the Show panel button.',
  'city.tour.keys.title': 'Moves',
  'city.tour.keys.body': 'The keyboard button shows every move your robot knows. On a phone you can turn on an action pad from there.',
  'city.tour.done.title': 'That is all',
  'city.tour.done.body': 'Enjoy {city}. You can take this tour again from the side panel.',
  'city.tour.step': '{n} of {total}',
  'city.tour.next': 'Next',
  'city.tour.back': 'Back',
  'city.tour.skip': 'Skip the tour',
  'city.tour.finish': 'Start exploring',
  'city.tour.again': 'Take the city tour again',
  'city.found.title': 'Places discovered',
  'city.found.count': '{n} of {total}',
  'city.found.none': 'Walk into a place to add it here.',
  'city.found.new': 'Discovered {place}',
  'city.board.open': 'Read the public notes board',
  'city.board.hint': 'Notes left here by other travellers. Pin up a short one of your own; no links, and up to three of yours stay up at a time.',
  'city.board.placeholder': 'Write a short note for others to find',
  'city.board.pin': 'Pin up the note',
  'city.board.loading': 'Reading the board…',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Take down your note',
  'city.board.err.signin': 'Sign in to pin up a note.',
  'city.board.err.soon': 'Wait a little before pinning up another note.',
  'city.board.err.bad': 'Notes must be plain text up to 200 characters, without links.',
  'city.board.err.down': 'The board cannot be reached right now.',
  'city.room.rent': 'Take a room at {place}',
  'city.room.move': 'Move your room to {place}',
  'city.room.yours': 'Your room at {place}',
  'city.room.decorate': 'Set something here',
  'city.room.remove': 'Take away the {thing}',
  'city.room.leave': 'Give up your room',
  'city.room.full': 'Your room has no space for more',
  'city.room.pickTitle': 'Furnish your room',
  'city.room.pickHint': 'Choose something to set on this spot. It stays in your room on this device.',
  'city.room.kind.rug': 'A woven rug',
  'city.room.kind.candle': 'A candle',
  'city.room.kind.flowers': 'A pot of flowers',
  'city.room.kind.painting': 'A painting',
  'city.room.kind.plant': 'A potted plant',
  'city.room.kind.chest': 'A little chest',
  'city.room.kind.lantern': 'A lantern',
  'city.room.kind.books': 'A few books',
  'city.busk.lute': '{name} plucks a bright tune nearby',
  'city.busk.fiddle': '{name} saws out a lively reel nearby',
  'city.busk.pipe': '{name} plays a slow air nearby',
  'city.busk.drum': '{name} beats out a dance nearby',
  'city.tail.label': 'Following {name}',
  'city.tail.title': 'Tailing {name} through the day',
  'city.tail.now': 'Now: {activity} at {place}',
  'city.tail.unknown': 'Their plans for now are unknown',
  'city.tail.next': 'Next: {place} at {time}, in {h} h {m} min',
  'city.tail.trail': 'Trailed through: {places}',
  'city.tail.stop': 'Stop following',
  'city.pins.add': 'Add a pin',
  'city.pins.tapMap': 'Tap the map to place your pin',
  'city.pins.walk': 'Walk to this pin',
  'city.pins.note': 'Pin at {x}, {y}. Add a note',
  'city.pins.noteLabel': 'Pin note',
  'city.pins.remove': 'Remove this pin',
  'city.pins.here': 'Pin this spot on the map',
  'city.compass.north': 'North',
  'city.compass.at': 'x {x}, y {y}, floor {floor}',
  'city.door.prop': 'Prop the door open',
  'city.door.close': 'Let the door swing shut',
  'city.door.unlock': 'Unlock the door',
  'city.door.lock': 'Lock the door',
  'city.books.browse': 'Browse the shelf',
  'city.books.shelf': 'Shelf at {place}',
  'city.books.book': 'Book',
  'city.books.scroll': 'Scroll',
  'city.books.prev': 'Previous',
  'city.books.back': 'Back to the shelf',
  'city.books.next': 'Next',
  'city.books.page': 'Page {n} of {of}',
  'city.sign.readSign': 'Read the sign',
  'city.sign.readPlaque': 'Read the plaque',
  'city.sign.sign': 'A painted sign',
  'city.sign.plaque': 'A plaque by the door',
  'city.district.entering': 'Now entering',
  'city.district.riverside': 'The Riverside and the Low Markets',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': 'The Lanes',
  'city.district.monastery': 'The Monastery',
  'city.district.castle': 'The Castle',
  'city.district.drains': 'The Old Drains',
  'city.district.farmlands': 'The Farmlands',
  'city.district.powerworks': 'The Powerworks',
  'city.district.guilds': 'The Guildhouses',
  'city.overview.hintMouse': 'Drag to look around, scroll to zoom. Click to walk. Arrow keys pan.',
  'city.overview.hintTouch': 'Drag to look around, pinch to zoom. Tap to walk.',
  'city.overview.spot': 'A spot on the map',
  'city.overview.walk': 'Walk here',
  'city.overview.look': 'Zoom in here',
  'city.overview.close': 'Close',
  'city.photo.enter': 'Photo mode',
  'city.photo.hint': 'Photo mode. Drag to look around; take a screenshot to keep it.',
  'city.photo.leave': 'Leave photo mode',
  'city.building.who': 'Who lives and works at {place}',
  'city.building.live': 'Lives here',
  'city.building.work': 'Works here',
  'city.building.now': 'Inside now',
  'city.building.rooms': 'Takes in {list}.',
  'city.inspect.about': 'About {name}',
  'city.inspect.close': 'Close',
  'city.inspect.unknown': 'Nobody can tell you much about {name}.',
  'city.inspect.home': 'Home',
  'city.inspect.work': 'Work',
  'city.inspect.none': 'None known',
  'city.inspect.today': 'Today',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Follow {name} through the day',
  'city.overlay.label': 'Map overlays',
  'city.overlay.crowd': 'Crowds',
  'city.overlay.light': 'Light',
  'city.overlay.noise': 'Noise',
  'city.bar.pop': '{n} live here',
  'city.bar.out': '{n} out now',
  'city.bar.season.spring': 'Spring',
  'city.bar.season.summer': 'Summer',
  'city.bar.season.autumn': 'Autumn',
  'city.bar.season.winter': 'Winter',
  'city.notebook.title': 'Heard and learned',
  'city.notebook.all': 'All',
  'city.notebook.heard': 'Heard',
  'city.notebook.learned': 'Learned',
  'city.notebook.search': 'Search your notes',
  'city.notebook.none': 'Nothing noted yet. Listen in the streets and talk to people.',
  'city.ask.title': 'Ask around',
  'city.ask.pick': 'Who are you looking for?',
  'city.ask.ask': 'Ask',
  'city.ask.passerby': 'A passer-by',
  'city.ask.nobody': 'There is no one close enough to ask. Find someone in the street.',
  'city.ask.unseen': '{asker} has not seen {who} about today.',
  'city.ask.here': '{asker} says {who} is near {place}.',
  'city.ask.go': 'Go to {who}',
  'city.weather.clear': 'Clear skies',
  'city.weather.cloudy.light': 'A few clouds',
  'city.weather.cloudy.heavy': 'Grey and overcast',
  'city.weather.rain.light': 'Light rain',
  'city.weather.rain.heavy': 'Heavy rain',
  'city.weather.fog.light': 'Morning mist',
  'city.weather.fog.heavy': 'Thick fog',
  'city.weather.snow.light': 'Light snow',
  'city.weather.snow.heavy': 'Heavy snow',
  'city.lamplighter.name': 'Lamplighter',
  'city.lamplighter.lighting': 'lighting the street lamps',
  'city.lamplighter.dousing': 'putting out the street lamps',
  'city.hourglass.title': 'Hourglass',
  'city.hourglass.stop': 'Stop the day',
  'city.hourglass.paused': 'The day stands still.',
  'city.hourglass.resume': 'Go on',
  'city.seat.bench': 'bench',
  'city.seat.chair': 'chair',
  'city.seat.pew': 'pew',
  'city.seat.throne': 'throne',
  'city.seat.helm': 'ship\'s wheel',
  'city.seat.taken': 'Someone is already at the {what}',
  'city.seat.helmTake': 'Take the wheel',
  'city.seat.helmHeld': 'You have the wheel. The riverboat is tied up at the pier, so she will not answer the helm yet.',
  'city.seat.sit': 'Sit on the {what}',
  'city.hide.in': 'You hide inside the {what}',
  'city.inside.crate': 'crate',
  'city.inside.barrel': 'barrel',
  'city.inside.title': 'Inside the {what}',
  'city.inside.look': 'Look in the {what}',
  'city.inside.holds': 'It is {fill}: {list}.',
  'city.factions.title': 'Standing in the city',
  'city.factions.wary': 'Wary',
  'city.factions.unknown': 'Unknown',
  'city.factions.noticed': 'Noticed',
  'city.factions.trusted': 'Trusted',
  'city.factions.honored': 'Honored',
  'city.factions.done': 'Errands done: {n}.',
  'city.mail.title': 'Letters',
  'city.mail.none': 'No letters yet.',
  'city.mail.from': 'From {name}',
  'city.mail.waiting': 'Waiting for a reply from {names}.',
  'city.mail.nobody': 'Help someone with an errand and you can write to them.',
  'city.mail.write': 'Write a letter',
  'city.mail.to': 'To whom',
  'city.mail.subject': 'Subject',
  'city.mail.body': 'Your letter',
  'city.mail.send': 'Send it',
  'city.mail.untitled': 'A few lines',
  'city.moth.title': "The Moth's tray",
  'city.moth.trade': 'Do the favor',
  'city.moth.yours': 'Yours now.',
  'city.spy.title': 'Quiet work',
  'city.cut.skip': 'Skip',
  'city.party.title': 'Play together',
  'city.party.blurb': 'Start a party and share its code with friends. Everyone in it sees each other anywhere in the city, not just in the shared spaces.',
  'city.party.start': 'Start a party',
  'city.party.codeLabel': 'Party code',
  'city.party.join': 'Join',
  'city.party.bad': 'A party code is four to eight letters or numbers.',
  'city.party.code': 'Your party code is {code}. Share it with friends so they can join.',
  'city.party.alone': 'Nobody else from your party is in the city right now.',
  'city.party.here': 'right beside you',
  'city.party.away': '{n} paces {dir}',
  'city.party.floor': '(floor {n})',
  'city.party.go': 'Go to',
  'city.party.leave': 'Leave the party',
  'city.party.dir.east': 'east',
  'city.party.dir.south-east': 'south-east',
  'city.party.dir.south': 'south',
  'city.party.dir.south-west': 'south-west',
  'city.party.dir.west': 'west',
  'city.party.dir.north-west': 'north-west',
  'city.party.dir.north': 'north',
  'city.party.dir.north-east': 'north-east',
  'city.print.title': 'Print a building',
  'city.print.here': '{name}: {w} by {d} cells, floors: {n}. Save it as an STL for a 3D printer.',
  'city.print.none': 'Stand in or beside a building to save it as an STL for a 3D printer.',
  'city.print.model': 'Save STL, model scale (5 mm a cell)',
  'city.print.tabletop': 'Save STL, tabletop scale (1 inch a cell)',
  'city.print.note': 'Walls, floors, doors, stairs and windows as the city draws them, on a base plate so it prints in one piece.',
  'city.print.models': 'Figures and props, ready to print:',
  'city.print.busy': 'Preparing…',
  'city.print.model.figure': 'Walker figure, 28 mm on a 25 mm base',
  'city.print.model.fountain': 'Fountain, 3 inches across',
  'city.print.model.castle-wall': 'Castle wall section, 3 inches long',
  'city.editor.stl': 'Save STL',
  'city.editor.title': 'City map editor',
  'city.editor.restricted': 'The city map editor is for the world\'s owner and its shardmasters. GMs run their campaigns on our maps from the campaign table.',
  'city.editor.accessChecking': 'Checking your access…',
  'city.editor.blurb': 'Open a living city to paint its live map, or start a blank map. Paint floor by floor: walls, streets, doors, water, ladders and named places. The check below reads it with the same map reader the living city uses. On a living city each stroke publishes; a blank map saves in this browser, and you can export it as a file to keep or share.',
  'city.editor.name': 'Map name',
  'city.editor.tools': 'Tools',
  'city.editor.tool.pen': 'Pen',
  'city.editor.tool.rect': 'Block',
  'city.editor.tool.room': 'Room',
  'city.editor.tool.fill': 'Fill',
  'city.editor.tool.spawn': 'Start point',
  'city.editor.tiles': 'Ground',
  'city.editor.letter': 'Letter',
  'city.editor.placeName': 'Place name',
  'city.editor.addPlace': 'Add place',
  'city.editor.placeBad': 'A place needs one letter and a name.',
  'city.editor.floors': 'Floors',
  'city.editor.addFloor': 'Add floor',
  'city.editor.map': 'Map',
  'city.editor.width': 'Width',
  'city.editor.height': 'Height',
  'city.editor.new': 'New map',
  'city.editor.undo': 'Undo',
  'city.editor.export': 'Export',
  'city.editor.import': 'Import',
  'city.editor.loaded': 'Map loaded.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Check',
  'city.editor.ok': 'Reads cleanly. {walk} open cells, {reach} reachable from the start point.',
  'city.editor.placeSpots': '{name}: {n} cells',
  'city.editor.canvas': 'Map canvas',
  'city.editor.open': 'Open a map',
  'city.editor.openCity': "{city} (today's map)",
  'city.editor.newBlank': 'New blank city',
  'city.editor.loading': 'Opening {city}...',
  'city.editor.openFailed': 'That map could not be opened. Try again, or start a new blank city.',
  'city.editor.basedOn': 'A copy of {city} as the living city runs it today: every floor, place, stair and door. Spoilers: secret rooms included.',
  'city.editor.editedCopy': 'Your edited copy of {city}. Spoilers: secret rooms included.',
  'city.editor.ownDraft': 'Your own map.',
  'city.editor.savedHere': 'Changes save only in this browser and never change the city other players visit. Export downloads a file to keep; clearing your browser data erases the draft.',
  'city.editor.under': 'Under',
  'city.editor.checking': 'Checking...',
  'city.editor.cursor': '{x}, {y}: {what}',
  'city.editor.live.asking': 'Asking the city server which cities you may edit...',
  'city.editor.live.openCity': '{city} (live)',
  'city.editor.live.openHidden': '{city} (hidden, staff only)',
  'city.editor.live.status': 'Live: {city}. {rows} changes so far, {players} players in the city.',
  'city.editor.live.publishesHere': 'Every stroke publishes to the living city: each game sees it once its clock reaches the stroke\'s time. Undo writes new changes; nothing is ever deleted.',
  'city.editor.live.cursor': '{x}, {y} (cube {cx}, {cy}, {cz} from the keep): {what}',
  'city.editor.live.playersHere': '{n} players on this floor, {all} in the city.',
  'city.editor.live.publishing': 'Publishing...',
  'city.editor.live.published': 'Published {n} cells.',
  'city.editor.live.refused': 'The server refused: {why}',
  'city.editor.live.failed': 'The city server could not be reached. Nothing more was published.',
  'city.editor.live.tooBig': 'That stroke is too big to publish at once (at most {n} cells). Paint a smaller area.',
  'city.editor.live.undone': 'Undone: new changes put those cubes back.',
  'city.editor.live.rolledBack': 'Rolled back: {n} reversing changes written.',
  'city.editor.live.time': 'Time',
  'city.editor.live.viewAt': 'Showing the map at: {when}',
  'city.editor.live.changedCells': '{n} cells differ from the base map at this time.',
  'city.editor.live.always': 'always (from the beginning)',
  'city.editor.live.latest': 'latest (every change)',
  'city.editor.live.takesEffect': 'Strokes take effect',
  'city.editor.live.at.always': 'Always (it was always like this)',
  'city.editor.live.at.slider': 'At the time shown',
  'city.editor.live.at.date': 'At a game date and time',
  'city.editor.live.day': 'Day',
  'city.editor.live.month': 'Month',
  'city.editor.live.year': 'Year',
  'city.editor.live.clock': 'Time of day',
  'city.editor.live.writesAt': 'The next stroke takes effect: {when}',
  'city.editor.live.changes': 'Recent changes',
  'city.editor.live.noChanges': 'No changes yet.',
  'city.editor.live.col.when': 'When',
  'city.editor.live.col.where': 'Where (x, y, z)',
  'city.editor.live.col.what': 'What',
  'city.editor.live.col.src': 'Source',
  'city.editor.live.col.who': 'Who',
  'city.editor.live.what.base': 'back to the base map',
  'city.editor.live.what.air': 'cleared',
  'city.editor.live.what.cube': '{detail}',
  'city.editor.live.what.assembly': 'assembly: {detail}',
  'city.editor.live.what.bad': 'unreadable',
  'city.editor.live.src.editor': 'editor',
  'city.editor.live.src.buy': 'purchase',
  'city.editor.live.src.destroy': 'destroyed in play',
  'city.editor.live.src.event': 'event',
  'city.editor.live.src.rollback': 'rollback',
  'city.editor.live.pick': 'Here',
  'city.editor.live.rollbackHere': 'Roll back this column',
  'city.editor.live.rollbackHereAt': 'Set the rollback area to column {x}, {y}',
  'city.editor.live.rollback': 'Roll back',
  'city.editor.live.rollbackArea': 'Area in cube coordinates, x and y counted from the keep. Leave it empty to match anywhere.',
  'city.editor.live.x0': 'West x',
  'city.editor.live.y0': 'North y',
  'city.editor.live.x1': 'East x',
  'city.editor.live.y1': 'South y',
  'city.editor.live.bySource': 'Source',
  'city.editor.live.anySource': 'Any source',
  'city.editor.live.byParty': 'Party (campaign id)',
  'city.editor.live.rollbackNeedsFilter': 'Choose an area, a source or a party first.',
  'city.editor.live.ok': 'OK',
  'city.editor.live.rollbackConfirm': 'Reverse every matching change? This writes new reversing changes, which every game sees at their times.',
  'city.editor.live.rollbackYes': 'Yes, roll back',
  'city.editor.live.cancel': 'Cancel',
  'city.editor.live.tile.wall': 'Wall',
  'city.editor.live.tile.street': 'Street or floor',
  'city.editor.live.tile.door': 'Door',
  'city.editor.live.tile.window': 'Window',
  'city.editor.live.tile.water': 'Water',
  'city.editor.live.tile.ladder': 'Ladder',
  'city.editor.live.tile.stairs': 'Stairs (landing)',
  'city.editor.live.tile.ivy': 'Ivy or drainpipe',
  'city.editor.live.tile.rail': 'Stair rail',
  'city.editor.live.tile.well': 'Stairwell',
  'city.editor.live.tile.landmark': 'Landmark',
  'city.editor.live.tile.air': 'Nothing (air)',
  'city.editor.live.tile.stemWall': 'Stem wall',
  'city.editor.live.tile.leafFloor': 'Leaf floor',
  'city.editor.live.tile.stemWalk': 'Stem walkway',
  'city.editor.live.tile.vineLadder': 'Vine ladder',
  'city.editor.live.tile.budDoor': 'Bud doorway',
  'city.editor.live.tile.leafWindow': 'Leaf window',
  'city.spy.take': 'Take it',
  'city.spy.again': 'Try again',
  'city.spy.drop': 'Let it go',
  'city.spy.progress': '{n} percent there.',
  'city.spy.carrying': 'You have the note.',
  'city.spy.underway': 'Underway.',
  'city.spy.done': 'Done.',
  'city.spy.failed': 'It went wrong last time.',
  'city.menu.look': 'Look at {thing}',
  'city.menu.street': 'The street',
  'city.menu.wall': 'A wall',
  'city.continue': 'Continue',
  'city.goodbye': 'Goodbye',
  'city.talk.replies': 'Your replies',
  'city.talk.keys': 'Press 1 to 9 to choose a reply, the arrow keys to move, Enter to pick, Escape to say goodbye.',
  'city.board.title': 'Bounty board',
  'city.arrive.rooftops': 'You pull yourself up onto the rooftops. The lanes open out below you, and the planks between the houses creak underfoot.',
  'city.arrive.museumRoof': 'You haul yourself up the old ivy onto the museum roof. Sunwalk Plaza spreads out below you like a game board.',
  'city.crier.title': "The crier's sheet",
  'city.crier.today': 'Today is {name}.',
  'city.crier.tomorrow': '{name} is tomorrow.',
  'city.crier.coming': '{name} in {n} days.',
  'city.crier.stalls': 'Out on the stalls at first light:',
  'city.crier.notices': '{n} notices on the bounty board.',
  'city.crier.talk': 'Talk of the town:',
  'city.crier.now': 'Happening around the city right now:',
  'city.board.empty': 'Nothing pinned up today. Check back tomorrow.',
  'city.board.posted': 'Posted by {name}.',
  'city.board.postedAt': 'Posted by {name}, now at {place}.',
  'city.board.days': '{n} days left.',
  'city.board.find': 'Find them',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Talking with {name}',
  'city.journal': 'Journal',
  'city.menu.self': 'You',
  'city.menu.inventory': 'Inventory',
  'city.menu.character': 'Character',
  'city.menu.party': 'Party',
  'city.items.pickUp': 'Pick up the {thing}',
  'city.items.lookAt': 'Look at the {thing}',
  'city.items.walkTo': 'Walk to the {thing}',
  'city.block.name': 'block',
  'city.block.strike': 'Strike the block',
  'city.block.state.0': 'A stone block stands here, whole and solid.',
  'city.block.state.1': 'The block is chipped at its edges and corners.',
  'city.block.state.2': 'Cracks run through the block.',
  'city.block.state.3': 'Parts of the block have come off and lie at its foot.',
  'city.block.state.4': 'The block has fallen in half.',
  'city.block.state.5': 'The block is smashed to pieces.',
  'city.block.state.6': 'The block is nothing but powder.',
  'city.block.hit.0': 'The block does not budge.',
  'city.block.hit.1': 'The block chips.',
  'city.block.hit.2': 'Cracks run through the block.',
  'city.block.hit.3': 'Parts of the block come off.',
  'city.block.hit.4': 'The block falls in half.',
  'city.block.hit.5': 'The block smashes to pieces.',
  'city.block.hit.6': 'The block turns to powder.',
  'city.journalNone': 'Nothing written yet.',
  'city.quests': 'Errands and threads',
  'city.questNone': 'None yet. Talk to people.',
  'city.rest': 'Rest {n} minutes',
  'city.saves.title': 'Saved games',
  'city.saves.slot': 'Slot {n}: {day} {time}, {place}',
  'city.saves.empty': 'Slot {n}: empty',
  'city.saves.save': 'Save here',
  'city.saves.load': 'Load',
  'city.saves.sure': 'Tap again to confirm',
  'city.saves.hint': 'A save keeps the whole city as it stands: where you are, the hour, the people, quests and chests. Loading puts it all back.',
  'city.restHint': 'Let time pass. You can only rest so much in an hour.',
  'city.bed.ask': 'Sleep in {bed}?',
  'city.bed.night': 'Eight hours pass while you sleep, and you rest by your game system\'s rules.',
  'city.bed.sleep': 'Sleep',
  'city.bed.notNow': 'Not now',
  'city.bed.tired': 'You are not tired yet. You can sleep again in about {n} hours.',
  'city.bed.asleep': 'Asleep. The night passes…',
  'city.bed.offer': 'Sleep here',
  'city.vitals': 'Health',
  'city.meters.toggle': 'Show the other gauges',
  'city.bed.woke': 'You sleep in {bed} and wake at {time}. {change}',
  'city.bed.change': '{label}: {before} to {after}.',
  'city.bed.noRest': 'The {system} rules give no recovery for rest, so nothing mends.',
  'city.bed.beds': 'Beds',
  'city.bed.demoRules': 'Rules for the bed test: {system}. Add ?rules=srd-5-2-1, zweihander or rat to the address to try another.',
  'city.messages': 'Notes',
  'city.rules': 'Game system',
  'city.rulesNarrative': 'No rules: the city as a story. Pick a system to see everyone in its numbers.',
  'city.statsFor': 'Numbers for',
  'city.sparTitle': 'Practice bout',
  'city.sparA': 'First fighter',
  'city.sparB': 'Second fighter',
  'city.sparVs': 'against',
  'city.sparRun': 'Fight',
  'city.sparNote': 'A demonstration in this system. Nobody in the city is hurt.',
  'city.sparRound': 'Round {n}.',
  'city.view.toFirst': 'First person',
  'city.view.toOverhead': 'Overhead view',
  'city.view.toggleHint': 'Switch between first person and the overhead view (P). Drag to look, W and S or the up and down arrows to walk, A and D or the left and right arrows to step sideways.',
  'city.view.forward': 'Walk forward',
  'city.view.backward': 'Walk back',
  'city.zoomIn': 'Zoom in',
  'city.pivot.left': 'Rotate view counterclockwise',
  'city.pivot.right': 'Rotate view clockwise',
  'city.pivot.north': 'Face north',
  'city.zoomOut': 'Zoom out',
  'city.centre': 'Center on me',
  'city.followOn': 'Follow on',
  'city.followOff': 'Follow off',
  'city.followOnHint': 'The camera follows you. Turn it off to pan freely.',
  'city.followOffHint': 'Pan and pinch anywhere. Tap ME to jump back to yourself.',
  'city.cubesOn': 'Cubes on',
  'city.cubesOff': 'Cubes off',
  'city.cubesHint': 'Draw the city from 5 ft cubes at their true heights. Turn off for the older storey view.',
  'city.shadowsOn': 'Shadows on',
  'city.shadowsOff': 'Shadows off',
  'city.shadowsHint': 'Sun shadows from walls, buildings and people',
  'city.invertTurn': 'Invert turn',
  'city.invertTurnHint': 'Which way dragging with the middle mouse button turns and tilts the view',
  'city.firstInvertX': 'Invert left/right',
  'city.firstInvertXHint': 'First person: on, the view turns the way you drag; off, dragging moves the view like grabbing it',
  'city.firstInvertY': 'Invert up/down',
  'city.firstInvertYHint': 'First person: on, dragging down looks down; off, dragging down looks up',
  'city.touchMove': 'Move',
  'city.touchTurn': 'Turn',
  'city.touchTurnHint': 'Move: drag to pan, pinch to zoom. Turn: one finger turns and tilts the view',
  'city.minimapShow': 'Show the map',
  'city.minimapHide': 'Hide the map',
  'city.minimapOpen': 'City map. Tap to open it larger.',
  'city.minimapWalk': 'City map. Tap a spot to walk there.',
  'city.minimapSmall': 'Make the map small',
  'city.minimapHint': 'Tap to walk there',
  // overheard talk between two people standing together (chatter/chatter.ts counts these per part of the day)
  'city.chatter.morning.1.a': 'Fresh bread at the corner ovens, if you hurry.',
  'city.chatter.morning.1.b': 'I smelled it two streets over. Save me a loaf.',
  'city.chatter.morning.2.a': "You're up early.",
  'city.chatter.morning.2.b': 'The bells woke me. They always do.',
  'city.chatter.morning.3.a': 'Did the carts come in through the gate?',
  'city.chatter.morning.3.b': 'Three of them, and one lost a wheel on the bridge.',
  'city.chatter.morning.4.a': 'Cold this morning.',
  'city.chatter.morning.4.b': 'The river fog will burn off by noon.',
  'city.chatter.morning.5.a': 'Where are you off to?',
  'city.chatter.morning.5.b': 'The market, before the good apples are gone.',
  'city.chatter.afternoon.1.a': 'Busy day at the stalls.',
  'city.chatter.afternoon.1.b': 'Too busy. My feet have given up on me.',
  'city.chatter.afternoon.2.a': 'Have you seen the tanner today?',
  'city.chatter.afternoon.2.b': 'He went down to the water an hour ago.',
  'city.chatter.afternoon.3.a': 'The sun is kind today.',
  'city.chatter.afternoon.3.b': 'Enjoy it. Rain is coming, I can feel it in my knee.',
  'city.chatter.afternoon.4.a': 'What did the fishmonger want for the eels?',
  'city.chatter.afternoon.4.b': 'Too much. I bought turnips instead.',
  'city.chatter.afternoon.5.a': 'Is that a new cart?',
  'city.chatter.afternoon.5.b': 'New to me. The wheels still squeak like the old one.',
  'city.chatter.evening.1.a': 'Going home already?',
  'city.chatter.evening.1.b': "Supper won't cook itself.",
  'city.chatter.evening.2.a': 'The lamps are coming on.',
  'city.chatter.evening.2.b': "Then I'm late again.",
  'city.chatter.evening.3.a': 'Will you be at the tavern tonight?',
  'city.chatter.evening.3.b': 'If my wife lets me, yes.',
  'city.chatter.evening.4.a': 'Long day.',
  'city.chatter.evening.4.b': 'They all are, this time of year.',
  'city.chatter.evening.5.a': 'Lock your shutters tonight.',
  'city.chatter.evening.5.b': 'I always do. The wind rattles them anyway.',
  'city.chatter.night.1.a': 'Who goes there?',
  'city.chatter.night.1.b': 'Only me. Put that lantern down.',
  'city.chatter.night.2.a': 'You should be asleep.',
  'city.chatter.night.2.b': 'So should you, friend.',
  'city.chatter.night.3.a': 'Did you hear something by the water?',
  'city.chatter.night.3.b': "Cats. It's always cats.",
  'city.chatter.night.4.a': 'Quiet night.',
  'city.chatter.night.4.b': "Let's keep it that way.",
  'city.chatter.any.1.a': 'Have you heard the news?',
  'city.chatter.any.1.b': 'Which news? There is always news.',
  'city.chatter.any.2.a': 'Good day to you.',
  'city.chatter.any.2.b': 'And to you.',
  'city.chatter.any.3.a': 'My cousin swears the old tower is haunted.',
  'city.chatter.any.3.b': 'Your cousin swears a lot of things.',
  'city.chatter.any.4.a': 'Prices keep going up.',
  'city.chatter.any.4.b': 'And my wages keep standing still.',
  'city.chatter.any.5.a': 'Mind the puddle there.',
  'city.chatter.any.5.b': 'Too late. Thank you anyway.',
  'city.chatter.any.6.a': 'Is that the stranger everyone mentions?',
  'city.chatter.any.6.b': "Don't stare. It's rude.",
  'city.chatter.any.7.a': 'How is your mother?',
  'city.chatter.any.7.b': "Better, thank you. She's back to scolding me.",
  'city.chatter.any.8.a': "I owe you a drink, don't I?",
  'city.chatter.any.8.b': 'Two, by my count.',
  'city.inventory.title': 'Your pack',
  'city.inventory.subtitle': 'Montkelian satchel',
  'city.inventory.close': 'Close your pack',
  'city.inventory.tabs': 'Pack sections',
  'city.inventory.tab.inventory': 'Inventory',
  'city.inventory.tab.journal': 'Journal',
  'city.inventory.tab.map': 'Map',
  'city.inventory.empty': 'Your pack is empty. Things you find on your travels will be stowed in these pockets.',
  'city.inventory.slots': 'Pockets',
  'city.inventory.slotEmpty': 'Pocket {n}, empty',
  'city.inventory.slot.headgear': 'Head',
  'city.inventory.slot.helmet': 'Head',
  'city.inventory.slot.hat': 'Head',
  'city.inventory.slot.hood': 'Head',
  'city.inventory.slot.amulet': 'Neck',
  'city.inventory.slot.cloak': 'Back',
  'city.inventory.slot.tabard': 'Torso',
  'city.inventory.slot.pelt': 'Back',
  'city.inventory.slot.armor': 'Chest',
  'city.inventory.slot.plate': 'Chest',
  'city.inventory.slot.robe': 'Chest',
  'city.inventory.slot.jerkin': 'Chest',
  'city.inventory.slot.hide': 'Chest',
  'city.inventory.slot.girdle': 'Waist',
  'city.inventory.slot.belt': 'Waist',
  'city.inventory.slot.bracers': 'Wrists',
  'city.inventory.slot.gloves': 'Hands',
  'city.inventory.slot.mainHand': 'Main hand',
  'city.inventory.slot.offHand': 'Off hand',
  'city.inventory.slot.twoHand': 'Both hands',
  'city.inventory.slot.sword': 'Main hand',
  'city.inventory.slot.shield': 'Off hand',
  'city.inventory.slot.staff': 'Main hand',
  'city.inventory.slot.focus': 'Off hand',
  'city.inventory.slot.ring': 'Finger',
  'city.inventory.slot.leggings': 'Legs',
  'city.inventory.slot.greaves': 'Shins',
  'city.inventory.slot.boots': 'Feet',
  'city.inventory.item.sword': 'Sword',
  'city.inventory.item.shield': 'Shield',
  'city.inventory.item.knife': 'Knife',
  'city.inventory.item.axe': 'Axe',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Cape',
  'city.inventory.item.ring': 'Ring',
  'city.inventory.class.default': 'traveller',
  'city.inventory.class.fighter': 'fighter',
  'city.inventory.class.paladin': 'paladin',
  'city.inventory.class.berserker': 'berserker',
  'city.inventory.class.wizard': 'wizard',
  'city.inventory.class.rogue': 'rogue',
  'city.inventory.slotFree': 'Empty',
  'city.inventory.gear': 'What you wear',
  'city.inventory.view': 'Show',
  'city.inventory.viewGear': 'Worn',
  'city.inventory.viewPockets': 'Pockets',
  'city.inventory.avatarHint': 'Choose a different avatar from the menu, under Avatar.',
  'city.inventory.soon.journal': 'Your journal is blank for now. Quests and notes you gather will be written here.',
  'city.inventory.soon.map': 'Your folded map will be kept here, marked with the places you have been.',
  'city.inventory.hint': 'Tap yourself to open your pack',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Choose your avatar',
  'city.avatar.robot': 'Robot',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladin',
  'city.avatarCloth': 'Cloth',
  'city.avatarClothHint': 'Capes and tabards swing as you move',
  'city.soundOn': 'Turn sound on',
  'city.soundOff': 'Turn sound off',
  'city.musicOn': 'Play music',
  'city.musicOff': 'Stop music',
  'city.walkSpeed': 'Speed',
  'city.walkSpeedLabel': 'Walking speed',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'me',
  'city.quality': 'Quality',
  'city.qualityAuto': 'Auto ({tier})',
  'city.tier.low': 'Low',
  'city.tier.medium': 'Medium',
  'city.tier.high': 'High',
  'city.robot.keys': 'Keyboard',
  'city.robot.title': 'Keyboard',
  'city.robot.intro': 'Press a key, or tap it here, and your robot acts it out for everyone nearby to see. Most keys are for show. The attack keys (1, 2 and 3) start a bout with your target, and the bout ends when they yield.',
  'city.robot.close': 'Close',
  'city.robot.jumpNote': 'Press Space again while in the air to double jump.',
  'city.robot.spellNote': 'In spell mode, 1, 2 and 3 cast instead of attack. Cast is quick; Cast spell charges up first.',
  'city.robot.climbNote': 'Page Up and Page Down climb the stairs, ladder, ivy or drainpipe closest to you. You can also walk onto or tap a stair to take it.',
  'city.robot.walkNote': 'W, A, S and D walk north, west, south and east one step at a time. Hold a key to keep walking. The arrow keys do the same.',
  'city.robot.walk.north': 'Walk north',
  'city.robot.walk.west': 'Walk west',
  'city.robot.walk.south': 'Walk south',
  'city.robot.walk.east': 'Walk east',
  'city.stairs.label': 'Take the stairs',
  'city.stairs.up': 'Up',
  'city.stairs.down': 'Down',
  'city.stairs.goUp': 'Go up a floor',
  'city.stairs.goDown': 'Go down a floor',
  'city.robot.toggleNote': 'Weapon mode, Spell mode, Sneak, Dance and Fall down stay on until you press them again.',
  'city.robot.targetNote': 'With your weapon out or in spell mode, click or tap someone to target them, then click or tap them again to attack. Tap open ground to clear. On a keyboard, Tab picks the next one and Esc clears it. Attack keys strike or cast at your target, stepping up to them first.',
  'city.robot.typing': 'The keys do nothing while you are typing in a box.',
  'city.robot.inSpell': 'Spell mode: {act}',
  'city.robot.otherwise': 'Otherwise: {act}',
  'city.robot.pad': 'Actions',
  'city.robot.padShow': 'Show the action pad',
  'city.robot.padHide': 'Hide the action pad',
  'city.robot.padTouch': '(for touch screens)',
  'city.robot.noLadder': 'No stairs or ladder close by',
  'city.robot.act.jump': 'Jump',
  'city.robot.act.double-jump': 'Double jump',
  'city.robot.act.dodge': 'Dodge',
  'city.robot.act.block': 'Block or defend',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Weapon mode',
  'city.robot.act.spell-mode': 'Spell mode',
  'city.robot.act.slash': 'Slash',
  'city.robot.act.thrust': 'Thrust',
  'city.robot.act.flurry': 'Flurry',
  'city.robot.act.cast': 'Cast',
  'city.robot.act.cast-spell': 'Cast spell',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Duck',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Sing',
  'city.robot.act.dance': 'Dance',
  'city.robot.act.barf': 'Barf',
  'city.robot.act.fall': 'Fall down or get up',
  'city.robot.act.climb-up': 'Climb up',
  'city.robot.act.climb-down': 'Climb down',
  'city.robot.act.hurt': 'Take a hit',
  'city.robot.act.kneel': 'Kneel and stand',
  'city.robot.act.bow': 'Bow',
  'city.robot.act.cheer': 'Cheer a victory',
  'city.panelShow': 'Show panel',
  'city.phone.menu': 'Menu',
  'city.phone.close': 'Close menu',
  'city.phone.view': 'Map',
  'city.phone.sound': 'Sound and pace',
  'city.phone.people': 'Find someone',
  'city.phone.more': 'Everything else',
  'city.phone.hint': 'Tap the ground to walk. Tap a person to talk.',
  'city.phone.gotIt': 'Got it',
  'city.panelHide': 'Hide panel',
  'city.canvasLabel3d': 'Map of {city} seen from above at an angle. Drag to look around, pinch or scroll to zoom, tap to walk or talk. The panel lists everyone and everything here too.',
  'city.dock.label': 'People to find',
  'city.dock.go': 'Walk to {name}',
  'city.dock.walking': 'Walking to {name}',
  'city.dock.toPlace': 'Walking to {name} at {place}',
  'city.dock.cancel': 'Tap the ground to stop',
  'city.cluster.party': 'With you',
  'city.cluster.quest': 'People in {title}',
  'city.quest.pick': 'Choose a quest to track',
  'city.quest.pickTracking': 'Tracking {title}. Choose another quest',
  'city.quest.picker': 'Quests',
  'city.quest.none': 'You have not found any quests yet.',
  'city.pet.empty': 'Pet slot, empty',
  'city.pet.hint': 'Finish a quest and an animal will take to you.',
  'city.pet.call': 'Call {name} to your side',
  'city.pet.with': '{name} is with you. Tap to call them close',
  'city.pet.name.street-dog': 'Street dog',
  'city.pet.name.lane-cat': 'Lane cat',
  'city.pet.name.plaza-pigeon': 'Plaza pigeon',
  'city.quest.close': 'Close',
  'city.quest.clear': 'Stop tracking',
  'city.quest.tracking': 'Tracking',
  'city.quest.locked': 'Locked',
  'city.quest.from': 'From {name}',
  'city.quest.state.active': 'Under way',
  'city.quest.state.offered': 'Offered',
  'city.quest.state.posted': 'On the board',
  'city.quest.reason.notOffered': 'Not offered yet. Speak with {name}.',
  'city.quest.reason.notOfferedAnon': 'Not offered yet.',
  'city.quest.reason.expired': 'Its time ran out.',
  'city.quest.reason.failed': 'It was lost.',
  'city.quest.reason.completed': 'Done.',
  'city.rigDebug.open': 'Debug how {name} moves',
  'city.rigDebug.title': 'Rig debug: {name}',
  'city.rigDebug.close': 'Close',
  'city.rigDebug.move': 'Move',
  'city.rigDebug.facing': 'Facing',
  'city.rigDebug.allMoves': 'All moves',
  'city.rigDebug.allFacings': 'All facings',
  'city.rigDebug.autoRotateOn': 'Auto-rotate: On',
  'city.rigDebug.autoRotateOff': 'Auto-rotate: Off',
  'city.rigDebug.resetView': "Reset view",
  'city.rigDebug.cycling': 'Cycling, {s} s each',
  'city.rigDebug.play': 'Play',
  'city.rigDebug.pause': 'Pause',
  'city.rigDebug.back': 'Step back one frame',
  'city.rigDebug.forward': 'Step forward one frame',
  'city.rigDebug.speed': 'Speed',
  'city.rigDebug.hint': "Drag with two fingers, or scroll on a trackpad, to move the view. Pause to step frame by frame. Tap outside or press Escape to close.",
  'city.rigDebug.anim.idle': 'Idle',
  'city.rigDebug.anim.walk': 'Walk',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'View',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isometric',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'facing {dir}',
  'city.rigDebug.cell': 'row {row}, frame {col}',
  'city.rigDebug.loading': 'loading',
  'city.rigDebug.clip': 'Clip',
  'city.rigDebug.allClips': 'All clips',
  'city.rigDebug.noClips': 'No clips',
  'city.rigDebug.layers': 'Show',
  'city.rigDebug.show.model': 'Model',
  'city.rigDebug.show.bones': 'Bones',
  'city.rigDebug.modes': "Engine modes",
  'city.rigDebug.weaponsOn': "Weapons out: On",
  'city.rigDebug.weaponsOff': "Weapons out: Off",
  'city.rigDebug.spellOn': "Spell mode: On",
  'city.rigDebug.spellOff': "Spell mode: Off",
  'city.rigDebug.boneCount': '{n} bones',
  'city.rigDebug.no3d': 'The 3D view could not start on this screen.',
  'city.rigDebug.hint3d': "Drag left or right to spin the figure, up or down to tilt it. Drag with two fingers, or scroll on a trackpad, to move the view. Pause to step frame by frame. Tap outside or press Escape to close.",
  'city.rigDebug.standIn': '{name} is shown on the {body} body here until her own is ready.',
  'city.rigDebug.archive': 'Archive',
  'city.rigDebug.archivePose': 'Pose preview: see how {name} moves',
  'city.pose.open': 'See how {name} moves',
  'city.pose.robot': 'You (robot stand-in)',
  'city.pose.you': 'You',
  'city.pose.see': 'See them move',
  'city.pose.youTitle': 'How you move',
  'city.pose.openYou': 'See how you move',
  'city.pose.title': 'How {name} moves',
  'city.pose.allTitle': 'All poses',
  'city.pose.all': 'Show all poses',
  'city.pose.one': 'Just {name}',
  'city.pose.close': 'Close',
  'city.pose.hint': 'Tap outside to close',
  'city.pose.loading': 'Loading',
  'city.pose.anim.idle': 'Idle',
  'city.pose.anim.walk': 'Walk',
  'city.pose.anim.talk': 'Talk',
  'city.pose.anim.sit': 'Sit',
  'city.pose.anim.run': 'Run',
  'city.pose.drag': 'Drag to turn',
  'city.pose.gait': 'Movement',
  'city.pose.model': '{name} in 3D',
  'city.pose.dir.SW': 'facing south-west',
  'city.pose.dir.SE': 'facing south-east',
  'city.pose.dir.NE': 'facing north-east',
  'city.pose.dir.NW': 'facing north-west',
  'city.demoLink': 'Open the renderer demo',
  'city.demoTitle': 'Renderer demo',
  'city.demoNote': 'A local preview of the 3D city with stand-in walkers. Nothing here talks to the game server.',
  'city.demoTime': 'Time of day',
  'city.demoSeason': 'Season',
  'city.demoPlay': 'Run the clock',
  'city.demoPause': 'Stop the clock',
  'city.demoTower': 'Test tower',
  'city.demoTowerNote': 'A four-storey building for checking what you can see indoors. Inside, the floors above you are cut away and anything you could not see from where you stand is greyed out. Tap a stair to take it, or use the arrows.',
  'city.demoGoTower': 'Walk to the tower',
  'city.demoFloor': 'Floor: {floor}',
  'city.demoFloor0': 'Ground',
  'city.demoFloor1': '2nd',
  'city.demoFloor2': '3rd',
  'city.demoFloor3': '4th',
  'city.demoFloor4': 'Roof',
  'city.demoWindow': '3rd floor window',
  'city.demoRoom': '3rd floor inner room',
  'city.demoUp': 'Up a floor',
  'city.demoDown': 'Down a floor',
  // Said when you walk into someone. Fixed lines for now; the dialogue AI may voice them per character later.
  'city.makeWay.polite': 'Oh, excuse me.',
  'city.makeWay.gruff': 'Hey, watch where you\'re walking.',
  'city.makeWay.immovable': 'I\'m not moving.',
  'city.makeWay.busy': 'Mind the way.',
  // Cascade Debugger (internal admin screen, read only). Prompt text itself is shown verbatim, never translated.
  'cascade.seoTitle': 'Cascade Debugger',
  'cascade.title': 'Cascade Debugger',
  'cascade.intro': 'Every prompt that shapes generated art, laid out as two family trees. The style side runs from the system down to the art director. The inheritor side is the whole taxonomy, from each shard root down to species and the lineages that sit on them. Open any row to read its full text.',
  'cascade.readOnly': 'Read only. Nothing on this screen can change a prompt.',
  'cascade.fetchedAt': 'Read from the content API at {time}',
  'cascade.refresh': 'Read again',
  'cascade.loading': 'Reading both cascades…',
  'cascade.error': 'Could not read the cascades from the content API. Try again in a moment.',
  'cascade.forbidden': 'This screen is for site admins. Your account is signed in but does not have the admin role.',
  'cascade.style.title': 'Style cascade',
  'cascade.style.subtitle': 'System, publisher, product line, setting, media type, book and art director. Each row inherits from the broader rows above it.',
  'cascade.style.focus': 'Follow the chain for',
  'cascade.style.counts': '{nodes} style rows, {edges} connections, {media} media templates',
  'cascade.taxa.title': 'Inheritor cascade',
  'cascade.taxa.subtitle': 'The full taxonomy. Each node adds its own prompt to everything it inherits from the nodes above it.',
  'cascade.taxa.group': 'Prompt group',
  'cascade.taxa.find': 'Find a taxon or lineage',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, a lineage name…',
  'cascade.taxa.counts': '{taxa} taxa, {prompts} taxon prompts, {lineages} lineages',
  'cascade.taxa.shardCounts': '{taxa} taxa, {prompts} prompt rows',
  'cascade.taxa.truncated': 'The content API capped this shard\'s prompt list, so some rows may be missing here.',
  'cascade.taxa.emptyShards': 'Shards with no taxa yet: {names}',
  'cascade.taxa.orphans': 'Lineages that point at a taxon not in any tree',
  'cascade.taxa.noOwn': 'No prompt of its own for this group.',
  'cascade.taxa.inherits': 'Inherits from above',
  'cascade.taxa.inheritsNothing': 'Nothing inherited. This is where the chain starts.',
  'cascade.taxa.through': 'Composed through this node',
  'cascade.taxa.lineages': 'Lineages on this species',
  'cascade.level.system': 'System',
  'cascade.level.publisher': 'Publisher',
  'cascade.level.product_line': 'Product line',
  'cascade.level.setting': 'Setting',
  'cascade.level.media': 'Media type',
  'cascade.level.book': 'Book',
  'cascade.level.art_director': 'Art director',
  'cascade.empty.system': 'No system style row on this chain.',
  'cascade.empty.publisher': 'No publisher style row exists yet. This level is empty.',
  'cascade.empty.product_line': 'No product line style row on this chain.',
  'cascade.empty.setting': 'No setting style row on this chain.',
  'cascade.empty.media': 'No media type templates apply to this chain.',
  'cascade.empty.book': 'No book style row hangs off this setting.',
  'cascade.empty.art_director': 'No art director is connected to this chain.',
  'cascade.missing': 'Missing level',
  'cascade.others': 'Other rows at this level ({count})',
  'cascade.mediaSpeciesNote': '{count} species templates are shown on the inheritor side, under their lineages.',
  'cascade.field.id': 'id',
  'cascade.field.scope': 'scope',
  'cascade.field.scopeId': 'scope id',
  'cascade.field.group': 'group',
  'cascade.field.mediaType': 'media type',
  'cascade.field.prompt': 'prompt',
  'cascade.field.negative': 'negative',
  'cascade.field.defaults': 'defaults',
  'cascade.field.refs': 'reference images',
  'cascade.field.chars': '{count} characters',
  'cascade.field.empty': 'empty',
  'cascade.facet.art_direction': 'Core',
  'cascade.facet.art_direction_character': 'Character',
  'cascade.facet.art_direction_scene': 'Scene',
  'cascade.facet.art_direction_interface': 'Interface',
  'cascade.facet.art_direction_cartography': 'Cartography',
  'cascade.facet.art_direction_audiobook': 'Audiobook',
  'cascade.facet.art_direction_movie': 'Movie',
  'cascade.facet.art_direction_short': 'Short',
  'cascade.facet.art_direction_tvshow': 'TV show',
  'cascade.composed.title': 'Composed for {name}',
  'cascade.composed.layers': 'Layers, broad to narrow',
  'cascade.composed.preview': 'Composed image prompt',
  'cascade.composed.previewNote': 'Assembled on this screen from the rows above in cascade order: style core, character facet, media templates, taxon traits, then the print line the generator adds in code. The live generator also adds framing and subject text.',
  'cascade.composed.negative': 'Composed negative',
  'cascade.composed.fromCode': 'added in code, not stored in any row',
  'cascade.flags.duplicates': 'Said twice',
  'cascade.flags.conflicts': 'Negative terms that also appear in the prompt',
  'cascade.flags.none': 'No repeated sentences and no negative terms that clash with the prompt.',
  'cascade.flags.in': 'in {sources}',
  'cascade.source.styleCore': 'style core',
  'cascade.source.styleCharacter': 'style character facet',
  'cascade.source.media': 'media template, {scope}',
  'cascade.source.taxon': 'taxon {rank} {value}',
  'cascade.source.printSafe': 'print line (code)',
  'cascade.rank.domain': 'domain',
  'cascade.rank.kingdom': 'kingdom',
  'cascade.rank.phylum': 'phylum',
  'cascade.rank.class': 'class',
  'cascade.rank.ordem': 'order',
  'cascade.rank.family': 'family',
  'cascade.rank.genus': 'genus',
  'cascade.rank.species': 'species',
  'cascade.rank.shard': 'shard',
  // the guild panel (guild/GuildPanel.tsx)
  'city.guild.open': 'Guild',
  'city.guild.openLabel': 'Open the guild panel',
  'city.guild.title': 'Your guild',
  'city.guild.refresh': 'Refresh',
  'city.guild.refused': 'Refused: {reason}',
  'city.guild.build': 'Build',
  'city.guild.buildBlurb': 'Lay walls, doors, paths and more on your grounds. Your grounds are outlined while you build.',
  'city.guild.stores': 'Stores',
  'city.guild.good.coin': 'Coin',
  'city.guild.good.food': 'Food',
  'city.guild.good.arms': 'Arms',
  'city.guild.good.lore': 'Lore',
  'city.guild.store': '{have} of {room}',
  'city.guild.machines': 'Machines',
  'city.guild.machinesNone': 'No machines stand on your grounds yet.',
  'city.guild.running': 'running',
  'city.guild.idle': 'idle',
  'city.guild.remove': 'Remove',
  'city.guild.catalog': 'Machines you can build',
  'city.guild.takes': 'takes {goods} an hour',
  'city.guild.makes': 'makes {goods} an hour',
  'city.guild.nothing': 'nothing',
  'city.guild.place': 'Place',
  'city.guild.research': 'Research',
  'city.guild.underWay': 'Under way',
  'city.guild.left': '{h} h {m} min left in game time',
  'city.guild.finishing': 'finishing now',
  'city.guild.available': 'Projects you can start',
  'city.guild.availableNone': 'Nothing left to research for now.',
  'city.guild.tier': 'tier {n}',
  'city.guild.cost': 'costs {cost}, takes {hours} game hours',
  'city.guild.start': 'Start',
  'city.guild.ledgerRefused': 'Refused by the ledger',
  'city.guild.researched': 'Researched: {list}',
  'city.guild.deposit': 'Put goods in the stores',
  'city.guild.depositHint': 'Only the GM can do this for now.',
  'city.guild.depositGo': 'Deposit',
  'city.guild.placeHint': 'Click a cell on your grounds to place {machine}. Escape cancels.',
  'city.guild.cancel': 'Cancel',
  'city.guild.buildHint': 'Pick a tile, then click or drag across cells on your grounds. Escape stops building.',
  'city.guild.buildDone': 'Done building',
  'city.guild.palette': 'Build palette',
  'city.guild.needs': 'Needs research first: {list}',
  'city.guild.or': 'or',
  'city.guild.tile.wall': 'Wall',
  'city.guild.tile.door': 'Door',
  'city.guild.tile.window': 'Window',
  'city.guild.tile.ladder': 'Ladder',
  'city.guild.tile.path': 'Path',
  'city.guild.tile.field': 'Field',
  'city.guild.tile.pond': 'Pond',
  'city.guild.tile.clear': 'Clear',
  'city.build.open': 'Build',
  'city.build.openHint': 'Build mode (B): spend your guild\'s coin to lay walls, doors, paths and more on your grounds',
  'city.build.key': 'Build mode',
  'city.build.title': 'Build',
  'city.build.treasury': 'Treasury: {n} coin',
  'city.build.next': 'Next drop: {cost}',
  'city.build.coin': '{n} coin',
  'city.build.free': 'free',
  'city.build.hint': 'Wheel picks. Click builds, right click clears. Shift and wheel zooms. Esc leaves.',
  'city.build.hintTouch': 'Swipe the list, tap to choose, then tap a cell to build.',
  'city.build.noGuild': 'You can build on the grounds around your guildhouse, and only a guild member has a guildhouse. You are not in a guild here, so there is nowhere for you to build yet. Ask a game master to bring you into their guild, then press B again.',
  'city.build.why.noGuild': 'You have no guild grounds to build on.',
  'city.build.why.tile': 'That cannot be built here.',
  'city.build.why.floor': 'Build on the ground or one storey up.',
  'city.build.why.outside': 'Outside your guild\'s grounds.',
  'city.build.why.house': 'The guildhouse itself cannot be changed.',
  'city.build.why.locked': 'Locked: your guild has not researched this yet.',
  'city.build.why.coins': 'Not enough coin in the Treasury.',
  'city.build.why.fast': 'Too fast: building takes time, wait a little.',
  'city.build.why.occupied': 'A machine stands here.',
  'city.items.title': 'Item catalog',
  'city.items.blurb': 'Every item the city knows, with its model. Search, filter by category, and click one to look at it from all sides.',
  'city.items.toEditor': 'Back to the map editor',
  'city.items.search': 'Search items',
  'city.items.all': 'All',
  'city.items.category': 'Category',
  'city.items.count': '{n} of {all} items',
  'city.items.empty': 'The catalog has no items yet.',
  'city.items.none': 'No item matches.',
  'city.items.value': 'Typical worth',
  'city.items.weight': 'Weight',
  'city.items.stack': 'Stacks to',
  'city.items.id': 'Id',
  'city.items.parts': 'Shapes',
  'city.items.tags': 'Tags',
  'city.items.close': 'Close',
  'city.items.angle': 'Seen turned {deg} degrees',
  'city.items.cat.food': 'Food',
  'city.items.cat.clothing': 'Clothing',
  'city.items.cat.arms': 'Arms',
  'city.items.cat.tools': 'Tools',
  'city.items.cat.household': 'Household',
  'city.items.cat.medicine': 'Medicine',
  'city.items.cat.books': 'Books',
  'city.items.cat.valuables': 'Valuables',
  'city.items.cat.religious': 'Religious',
  'city.items.cat.leisure': 'Leisure',
  'city.items.cat.travel': 'Travel',
  'city.items.cat.animals': 'Animals',
  'city.items.cat.security': 'Security',
  'city.items.cat.quest': 'Quest',
  'city.items.cat.junk': 'Junk',
  'city.editor.tool.item': 'Items',
  'city.editor.items.title': 'Items',
  'city.editor.items.mode': 'Place or remove',
  'city.editor.items.mode.place': 'Place',
  'city.editor.items.mode.remove': 'Remove',
  'city.editor.items.pick': 'Pick an item below, then click the map to place it on a cell.',
  'city.editor.items.selected': 'Placing: {name}',
  'city.editor.items.turnLeft': 'Turn left',
  'city.editor.items.turnRight': 'Turn right',
  'city.editor.items.turn': 'Turned {deg} degrees',
  'city.editor.items.raise': 'Raise (cubes)',
  'city.editor.items.removeHint': 'Click a cell to take away every item lying on it.',
  'city.editor.items.placed': 'Placed {name}.',
  'city.editor.items.removed': 'Took away {n} items.',
  'city.editor.items.nothingHere': 'No item lies on that cell.',
  'city.editor.items.liveOnly': 'Items are placed on a living city. Open one first.',
  'city.editor.items.onMap': '{n} items on the map at this time.',
  'city.editor.items.gallery': 'Open the catalog',
  'city.editor.live.what.item': 'placed: {detail}',
  'city.editor.live.what.itemGone': 'item taken away',
  'city.inventory.tab.things': 'Things',
  'city.inventory.things.title': 'What you carry',
  'city.inventory.things.slots': '{used} of {max} slots',
  'city.inventory.things.weight': 'weight {w}',
  'city.inventory.things.worth': 'worth {v}',
  'city.inventory.things.empty': 'You carry nothing yet. Pick things up from the ground.',
  'city.inventory.things.unknown': 'Unknown thing',
  'city.inventory.things.each': 'Worth about {v}, {w} each.',
  'city.inventory.things.qty': 'Amount',
  'city.inventory.things.inspect': 'Inspect',
  'city.inventory.things.drop': 'Drop',
  'city.inventory.things.dropN': 'Drop {n}',
  'city.inventory.things.give': 'Give to someone near',
  'city.inventory.things.giveTo': 'Give to {name}',
  'city.inventory.things.noMates': 'Nobody is near enough to give things to.',
  'city.inventory.things.nearby': 'On the ground near you',
  'city.inventory.things.nearbyNone': 'Nothing within reach.',
  'city.inventory.things.pickUp': 'Pick up {name}',
  'city.inventory.things.pickUpShort': 'Pick up',
}
